import React from 'react';
import { Navigation } from './components/Navigation/Navigation';
import { Footer } from './components/Footer/Footer';
import { HeaderIcon } from './components/HeaderIcon/HeaderIcon';
import { SidebarFooter, SidebarHeader, SidebarWrapper, SidebarNavigationContainer } from './styles';
import { useSidebarContext } from './SidebarContext';

export const Sidebar: React.FC = () => {
  const { isCollapsed, toggleSidebar } = useSidebarContext();
  return (
    <>
      <SidebarWrapper flexColumn $isCollapsed={isCollapsed}>
        <SidebarHeader>
          <HeaderIcon hide={isCollapsed} toggle={toggleSidebar} />
        </SidebarHeader>
        <SidebarNavigationContainer>
          <Navigation hide={isCollapsed} />
        </SidebarNavigationContainer>
        <SidebarFooter>
          <Footer />
        </SidebarFooter>
      </SidebarWrapper>
    </>
  );
};
